import {
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_ADD_NEW_USER_FAILURE,
  ACCOUNT_ADD_NEW_USER_REQUEST,
  ACCOUNT_ADD_NEW_USER_SUCCESS,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST,
  ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_GET_USER_DETAILS_FAILURE,
  ACCOUNT_GET_USER_DETAILS_REQUEST,
  ACCOUNT_GET_USER_DETAILS_SUCCESS,
  RESET_DELETE_SUCCESS_MESSAGE,
  ACCOUNT_TABS_STATUS_REQUEST,
  ACCOUNT_TABS_STATUS_SUCCESS,
  ACCOUNT_TABS_STATUS_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_SUCCESS,
  ACCOUNT_TRANSACTION_HISTORY_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS,
  ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS,
  SELECT_BILLING_ACCOUNT_DETAIL_NUMBER,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS,
  ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE,
  ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS,
  ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE,
  ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS,
  ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE,
  ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS,
  ACCOUNT_GET_ACCOUNT_PAGE_FAILURE,
  ACCOUNT_GET_ACCOUNT_PAGE_REQUEST,
  ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS,
  ACCOUNT_UPLOAD_DOCUMENTS_FAILURE,
  ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS,
  ACCOUNT_DELETE_DOCUMENT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_SUCCESS,
  ACCOUNT_GET_PROFILE_FAILURE,
  ACCOUNT_GET_PROFILE_REQUEST,
  ACCOUNT_GET_PROFILE_SUCCESS,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST,
  ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS,
  ACCOUNT_UPDATE_PROFILE_FAILURE,
  ACCOUNT_UPDATE_PROFILE_REQUEST,
  ACCOUNT_UPDATE_PROFILE_SUCCESS,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS,
  BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE,
  CHANGE_BILLING_ADDRESS_REQUEST,
  CHANGE_BILLING_ADDRESS_SUCCESS,
  CHANGE_BILLING_ADDRESS_FAILURE,
  CHANGE_BILLING_ADDRESS_RESET,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST,
  ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST,
  ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS,
  ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS,
  ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE,
  ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS,
  ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE,
  ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS
} from '@/actions/account/actionTypes';

export const PROFILE_ERROR_CODE = {
  'INTERNAL-SERVER-ERROR': 'PROFILE_ERROR_INTERNAL_SERVER',
  'PROFILE-NOT-FOUND': 'PROFILE_ERROR_NOT_FOUND',
  'INVALID-DOCUMENT-ID': 'PROFILE_ERROR_INVALID_DOCUMENT_ID',
  'INVALID-FILE-TYPE': 'PROFILE_ERROR_INVALID_FILE_TYPE',
  'INVALID-FILE-SIZE': 'PROFILE_ERROR_INVALID_FILE_SIZE'
};

export const initialState = {
  isLoading: false,
  isUpdating: false,
  errorDocuments: '',
  errorProfile: '',
  errorAccountPage: null,
  profile: {
    name: '',
    phone: '',
    email: '',
    brn: '',
    lastname: '',
    finExpiryDate: '',
    documents: []
  },
  unmaskedProfile: {
    name: '',
    phone: '',
    email: '',
    lastname: '',
    brn: '',
    companyName: ''
  },
  accountPage: {
    isPageLoading: false,
    list: [],
    currentPage: 1,
    pageCount: 1,
    searchTerm: ''
  },
  documentRepo: {},
  isLoadingList: false,
  policyList: [],
  policyTemplate: [],
  pagination: {},
  policyDetails: {},
  isLoadingPolicyDetails: false,
  isDeleting: false,
  brnList: [],
  transHistory: {
    tabDetails: [],
    isLoadingTabDetails: false,
    transHistoryData: [],
    totalRecords: 1,
    isLoadingTransHistory: false,
    transHistoryOrderDetails: {},
    transHistoryError: '',
    transOrderDetails: {}
  },
  transOrderDetails: {},
  changeUserDetails: {},
  isAddressLoading: false,
  addressList: [],
  residentialAddList: [],
  deleteAddressSuccessMsg: '',
  saveAddressSuccessMsg: '',
  canceledOrder: {},
  isCancelSuccess: false,
  billingList: [],
  enrollmentStatus: {},
  billingaddressDetail: {},
  billingNumberList: [],
  cardDetails: {},
  transactionhistorydetail: {},
  totalRecords: 0,
  errorMRCEnrol: '',
  isLoadingMRCEnrol: false,
  changebillingaddressLoading: false,
  changeBillingAddress: {},
  changeBillingAddressError: '',
  errorHomeDeliveryAddr: ''
};

const getTransHistoryDetails = (action, state) => {
  const actionType = action.type;
  switch (actionType) {
    case ACCOUNT_TABS_STATUS_REQUEST:
      return {
        ...state,
        isLoadingTabDetails: true,
        transHistoryError: ''
      }
    case ACCOUNT_TABS_STATUS_SUCCESS:
      return {
        ...state,
        tabDetails: action.data,
        isLoadingTabDetails: false
      }
    case ACCOUNT_TABS_STATUS_FAILURE:
      return {
        ...state,
        tabDetails: [],
        isLoadingTabDetails: false,
        transHistoryError: action.error.response?.data?.message
      }

    case ACCOUNT_TRANSACTION_HISTORY_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST:
      return {
        ...state,
        isLoadingTransHistory: true,
        transHistoryError: ''
      }
    case ACCOUNT_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        transHistoryData: action.data?.t1 || [],
        totalRecords: action.data?.t2 || 0,
        isLoadingTransHistory: false,
      }
    case ACCOUNT_TRANSACTION_HISTORY_FAILURE:
      return {
        ...state,
        transHistoryData: [],
        totalRecords: 0,
        isLoadingTransHistory: false,
        transHistoryError: action.error.response?.data?.message,
      }

    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS:
      return {
        ...state,
        isLoadingTransHistory: false,
        transHistoryOrderDetails: action.data
      }
    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE:
      return {
        ...state,
        isLoadingTransHistory: false,
        transHistoryOrderDetails: {},
        transHistoryError: action.error.response?.data?.message
      }
  }
}

const getAccountDetails = (action, state) => {
  const actionType = action.type;
  if (actionType === ACCOUNT_GET_ACCOUNT_PAGE_REQUEST) {
    return {
      ...state,
      accountPage: {
        ...state.accountPage,
        isPageLoading: true
      }
    }
  } else if (actionType === ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS) {
    const { brnList = [], currentPage = 1, pageSize, totalRecords = 1 } = action.data;
    return {
      ...state,
      accountPage: {
        ...state.accountPage,
        isPageLoading: false,
        list: brnList,
        currentPage,
        pageCount: Math.floor(totalRecords / pageSize)
      }
    }
  } else {
    const { error } = action;
    return {
      ...state,
      accountPage: {
        ...state.accountPage,
        isPageLoading: false,
        list: []
      },
      errorAccountPage: error
    }
  }
}

const getTransactionHistoryUpdate = (action, state) => {
  switch (action.type) {
    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE:
      return {
        ...state,
        canceledOrder: {},
        isCancelSuccess: false
      }

    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS:
      return {
        ...state,
        canceledOrder: action.data,
        isCancelSuccess: true
      }

    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE:
      return {
        ...state,
        isCancelSuccess: false
      }

    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS:
      return {
        ...state,
        isCancelSuccess: true
      }
  }
}

const getMRCError = (action, state) => {
  const actionType = action.type;
  if (actionType === BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST) {
    return {
      ...state,
      isLoadingMRCEnrol: true,
      errorMRCEnrol: ''
    }
  }
  if (actionType === BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS) {
    return {
      ...state,
      isLoadingMRCEnrol: false
    }
  }
  if (actionType === BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE) {
    return {
      ...state,
      isLoadingMRCEnrol: false,
      errorMRCEnrol: action.error.response?.data?.message
    }
  }
}

const getChangeBilling = (action, state) => {
  const actionType = action.type;
  if (actionType === CHANGE_BILLING_ADDRESS_REQUEST) {
    return {
      ...state,
      changebillingaddressLoading: true
    }
  }
  if (actionType === CHANGE_BILLING_ADDRESS_SUCCESS) {
    return {
      ...state,
      changeBillingAddress: action.data,
      changebillingaddressLoading: false
    };
  }
  if (actionType === CHANGE_BILLING_ADDRESS_FAILURE) {
    return {
      ...state,
      changeBillingAddressError: action.error.response?.data?.message,
      changeBillingAddress: {},
      changebillingaddressLoading: false
    };
  }
  if (actionType === CHANGE_BILLING_ADDRESS_RESET) {
    return {
      ...state,
      changeBillingAddressError: '',
      changeBillingAddress: {},
      changebillingaddressLoading: false
    };
  }
}

const getSpocTransHistoryDetail = (action, state) => {
  const actionType = action.type;
  if ([ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST, ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE].includes(actionType)) {
    return {
      ...state,
      transOrderDetails: {}
    }
  }
  if (actionType === ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS) {
    return {
      ...state,
      transOrderDetails: action.data
    }
  }
}

const getUserDetails = (action, state) => {
  const actionType = action.type;
  if (actionType === ACCOUNT_GET_USER_DETAILS_SUCCESS) {
    return {
      ...state,
      changeUserDetails: action.data?.data,
      isLoading: false
    }
  }
  if (actionType === ACCOUNT_GET_USER_DETAILS_FAILURE) {
    return {
      ...state,
      changeUserDetails: {},
      isLoading: false
    }
  }
}

const getDeleteDeliveryAddress = (action, state) => {
  const actionType = action.type;
  if (actionType === ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST) {
    return {
      ...state,
      isDeleting: true,
      isAddressLoading: true
    }
  }
  if (actionType === ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE) {
    return {
      ...state,
      isDeleting: false,
      isAddressLoading: false
    }
  }
  if (actionType === ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS) {
    return {
      ...state,
      isDeleting: false,
      isAddressLoading: false,
      deleteAddressSuccessMsg: Object.keys(action.data).length ? 'success' : ''
    }
  }
}
const accountReducers = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_GET_PROFILE_REQUEST:
    case ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST:
    case ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST:
    case ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST:
    case ACCOUNT_ADD_NEW_USER_REQUEST:
    case ACCOUNT_GET_USER_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case ACCOUNT_UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        isUpdating: true
      };

    case ACCOUNT_GET_ACCOUNT_PAGE_REQUEST:
    case ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS:
    case ACCOUNT_GET_ACCOUNT_PAGE_FAILURE:
      return getAccountDetails(action, state)

    case ACCOUNT_GET_PROFILE_SUCCESS:
    case ACCOUNT_UPDATE_PROFILE_SUCCESS:
      {
        const { name, phone, email, brn, documents, lastname, finExpiryDate } = action.data;
        return {
          ...state,
          isLoading: false,
          isUpdating: false,
          errorProfile: '',
          profile: {
            ...state.profile,
            name,
            phone,
            email,
            brn,
            documents,
            lastname,
            finExpiryDate
          }
        }
      }

    case ACCOUNT_GET_PROFILE_FAILURE:
    case ACCOUNT_UPDATE_PROFILE_FAILURE:
    case ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE:
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        errorProfile: PROFILE_ERROR_CODE[action.error.response?.data?.code || 'PROFILE-NOT-FOUND']
      }

    case ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS: {
      const { userName, lastname, phone, userEmail, brn, companyName } = action.data;
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        errorProfile: '',
        unmaskedProfile: {
          name: userName,
          lastname: lastname,
          phone: phone,
          email: userEmail,
          brn,
          companyName
        }
      }
    }
    case ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS:
    case ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorDocuments: ''
      }

    case ACCOUNT_DELETE_DOCUMENT_SUCCESS:
    case ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS: {
      const { documentRepo } = action.data;
      return {
        ...state,
        isLoading: false,
        errorDocuments: '',
        documentRepo
      }
    }
    case ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS:
    case ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorDocuments: '',
        documentRepo: {
          ...state.documentRepo,
          ...action.data
        }
      }

    case ACCOUNT_UPLOAD_DOCUMENTS_FAILURE:
    case ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE:
    case ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE:
    case ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE:
    case ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorDocuments: PROFILE_ERROR_CODE[action.error.response?.data?.code || 'PROFILE-NOT-FOUND']
      }

    case ACCOUNT_DELETE_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorDocuments: PROFILE_ERROR_CODE['INTERNAL-SERVER-ERROR']
      }


    // case ACCOUNT_GET_POLICY_LSIT_REQUEST:
    // case ACCOUNT_GET_POLICY_LSIT_FAILURE:
    //   return {
    //     ...state,
    //     isLoadingList: false,
    //     policyList: [],
    //     pagination: {}
    //   }

    // case ACCOUNT_GET_POLICY_LSIT_SUCCESS:
    //   return {
    //     ...state,
    //     isLoadingList: false,
    //     policyList: action.data.data,
    //     pagination: action.data.pagination
    //   }

    // case ACCOUNT_GET_POLICY_TEMPLATE_FAILURE:
    //   return {
    //     ...state,
    //     policyTemplate: [],
    //     policyDetails: {}
    //   }

    // case ACCOUNT_GET_POLICY_TEMPLATE_SUCCESS:
    //   return {
    //     ...state,
    //     policyTemplate: action.data.data.permissions,
    //     policyDetails: {}
    //   }

    // case ACCOUNT_GET_POLICY_DETAILS_REQUEST:
    //   return {
    //     ...state,
    //     policyDetails: {},
    //     isLoadingPolicyDetails: true
    //   }

    // case ACCOUNT_GET_POLICY_DETAILS_SUCCESS:
    //   return {
    //     ...state,
    //     policyDetails: action.data.data,
    //     isLoadingPolicyDetails: false
    //   }

    // case ACCOUNT_GET_POLICY_DETAILS_FAILURE:
    //   return {
    //     ...state,
    //     policyDetails: {},
    //     isLoadingPolicyDetails: false
    //   }

    // case ACCOUNT_SAVE_POLICY_SUCCESS:
    // case ACCOUNT_SAVE_POLICY_FAILURE:
    //   return {
    //     ...state,
    //     isUpdating: false
    //   }

    // case ACCOUNT_DELETE_POLICY_REQUEST:
    //   return {
    //     ...state,
    //     isDeleting: true
    //   }

    // case ACCOUNT_DELETE_POLICY_SUCCESS:
    // case ACCOUNT_DELETE_POLICY_FAILURE:
    //   return {
    //     ...state,
    //     isDeleting: false
    //   }

    case ACCOUNT_TABS_STATUS_REQUEST:
    case ACCOUNT_TABS_STATUS_SUCCESS:
    case ACCOUNT_TABS_STATUS_FAILURE:
    case ACCOUNT_TRANSACTION_HISTORY_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_SUCCESS:
    case ACCOUNT_TRANSACTION_HISTORY_FAILURE:
    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS:
    case ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE:
      return {
        ...state,
        transHistory: getTransHistoryDetails(action, state.transHistory)
      }

    case ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE:
    case ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS:
      return getSpocTransHistoryDetail(action, state)

    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS:
    case ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE:
    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST:
    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS:
    case ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE:
      return getTransactionHistoryUpdate(action, state)

    case ACCOUNT_GET_USER_DETAILS_SUCCESS:
    case ACCOUNT_GET_USER_DETAILS_FAILURE:
      return getUserDetails(action, state)


    case ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST:
    case ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST:
    case ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST:
    case ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST:
      return {
        ...state,
        isAddressLoading: true,
        errorHomeDeliveryAddr: ''
      }

    case ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        isAddressLoading: false,
        addressList: action.data,
        errorHomeDeliveryAddr: ''
      }

    case ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        isAddressLoading: false,
        residentialAddList: action.data,
        errorHomeDeliveryAddr: ''
      }

    case ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE:
    case ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE:
    case ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE:
    case ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE:
      return {
        ...state,
        isAddressLoading: false,
        errorHomeDeliveryAddr: action.error.response?.data?.message
      }

    case ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST:
    case ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE:
    case ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS:
      return getDeleteDeliveryAddress(action, state)

    case ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS:
    case ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        isAddressLoading: false,
        saveAddressSuccessMsg: Object.keys(action.data).length ? 'success' : '',
        errorHomeDeliveryAddr: ''
      }

    case RESET_DELETE_SUCCESS_MESSAGE:
      return {
        ...state,
        isAddressLoading: false,
        deleteAddressSuccessMsg: action.message
      }

    case ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billingList: action.data.paymentMethodList,
        totalRecords: action.data.numberOfRecords
      };

    case ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE:
    case ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE:
    case ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST:
    case ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE:
    case ACCOUNT_ADD_NEW_USER_SUCCESS:
    case ACCOUNT_ADD_NEW_USER_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        enrollmentStatus: action.data
      };

    case SELECT_BILLING_ACCOUNT_DETAIL_NUMBER:
      return {
        ...state,
        isLoading: false,
        billingaddressDetail: action.billingaddress,
        errorMRCEnrol: ''
      };

    case ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS:
      return {
        ...state,
        isLoading: true,
        billingNumberList: action.data
      };

    case BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST:
    case BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS:
    case BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE:
      return getMRCError(action, state)

    case CHANGE_BILLING_ADDRESS_REQUEST:
    case CHANGE_BILLING_ADDRESS_SUCCESS:
    case CHANGE_BILLING_ADDRESS_FAILURE:
    case CHANGE_BILLING_ADDRESS_RESET:
      return getChangeBilling(action, state)

    default:
      return state
  }
};

export default accountReducers;